import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { checkOwner } from "../lib/auth";

// Landing pad after Google sign-in: photographers go to the inbox,
// customers go to their games.
export default function AuthDest() {
  useEffect(() => {
    (async () => {
      const owner = await checkOwner();
      window.location.replace(owner ? "/inbox" : "/my-games");
    })();
  }, []);
  return (
    <div className="flex min-h-screen items-center justify-center bg-ink font-body text-white" data-testid="auth-dest-page">
      <p className="flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.2em] text-white/60">
        <Loader2 className="h-5 w-5 animate-spin text-accentlight" /> One moment…
      </p>
    </div>
  );
}